import React, { useState, useEffect } from 'react'

import { useTranslation } from 'react-i18next'

import ErrorModal from '../../../../../components/error-modal/error-modal'
import ActionErrorModal from '../../../../../components/action-error-modal/ActionErrorModal'
import { Icon } from '../../../../../components/Component'

import { useEndpointStatusData, useEndpointStatusActions } from '../../../../../store/endpointStatus'
import { useGlobalStoreData } from '../../../../../store/globalStore'
import McPageHelpers from '../../../../../pages/mc-components/McPageHelpers'

const showErrorModal = (fireErrorModal, fireActionErrorModal, errorMessage, t, languageGSD) => {
  const buildMessage = (baseMessage, errorMessage) => {
    return (
      <>
        <div>{baseMessage}</div>
        {(errorMessage.requestedValue != null && errorMessage.requestedValue !== undefined) && (
          <div style={{ marginTop: '8px' }}>{t('mailTemplate.ruleTypeErrors.requested_value', { requestedValue: errorMessage.requestedValue })}</div>
        )}
        {(errorMessage.asyncRequestedValue != null && errorMessage.asyncRequestedValue !== undefined) && (
          <div style={{ marginTop: '4px' }}>{t('mailTemplate.ruleTypeErrors.async_requested_value', { asyncRequestedValue: errorMessage.asyncRequestedValue })}</div>
        )}
      </>
    )
  }
  switch (errorMessage?.ruleType) {
    case 'AI_REL_CHECK':
      fireActionErrorModal(
        t('mailTemplate.ruleTypeErrors.ai_rel_check_title', { limit: errorMessage.limit }),
        buildMessage(
          t('mailTemplate.ruleTypeErrors.ai_rel_check_text', { currentValue: errorMessage.currentValue }),
          errorMessage
        ),
        errorMessage
      )
      break
    case 'AI_EMAIL_GEN':
      fireErrorModal(
        t('mailTemplate.ruleTypeErrors.ai_email_gen_title', { limit: errorMessage.limit }),
        buildMessage(
          t('mailTemplate.ruleTypeErrors.ai_email_gen_text', { currentValue: errorMessage.currentValue }),
          errorMessage
        )
      )
      break
    case 'B2B_TOTAL_EMAIL_COUNT':
      fireErrorModal(
        t('mailTemplate.ruleTypeErrors.b2b_total_email_count_title', { limit: errorMessage.limit }),
        buildMessage(
          t('mailTemplate.ruleTypeErrors.b2b_total_email_count_text', { currentValue: errorMessage.currentValue }),
          errorMessage
        )
      )
      break
    case 'B2B_CAMPAIGN_COUNT':
      fireErrorModal(
        t('mailTemplate.ruleTypeErrors.b2b_campaign_count_title', { limit: errorMessage.limit }),
        buildMessage(
          t('mailTemplate.ruleTypeErrors.b2b_campaign_count_text', { currentValue: errorMessage.currentValue }),
          errorMessage
        )
      )
      break
    case 'B2B_HS_CODE_COUNT':
      fireErrorModal(
        t('mailTemplate.ruleTypeErrors.b2b_hs_code_count_title', { limit: errorMessage.limit }),
        buildMessage(
          t('mailTemplate.ruleTypeErrors.b2b_hs_code_count_text', { currentValue: errorMessage.currentValue }),
          errorMessage
        )
      )
      break
    case 'B2B_HS_CODE_SET':
      fireErrorModal(
        t('mailTemplate.ruleTypeErrors.b2b_hs_code_set_text'),
        <>
          {errorMessage.customMessage.split(',').map((obj, index) => <span key={index}>{McPageHelpers.findCountryName(obj)}<br/></span>)}
          {(errorMessage.requestedValue != null && errorMessage.requestedValue !== undefined) && (
            <div>{t('mailTemplate.ruleTypeErrors.requested_value', { requestedValue: errorMessage.requestedValue })}</div>
          )}
          {(errorMessage.asyncRequestedValue != null && errorMessage.asyncRequestedValue !== undefined) && (
            <div>{t('mailTemplate.ruleTypeErrors.async_requested_value', { asyncRequestedValue: errorMessage.asyncRequestedValue })}</div>
          )}
        </>
      )
      break
    case 'B2B_SEARCH_COUNTRY_SET':
      fireErrorModal(
        t('mailTemplate.ruleTypeErrors.b2b_search_country_set_title'),
        <>
          {errorMessage.customMessage.split(',').map((obj, index) => <span key={index}>{McPageHelpers.findCountryName(obj)}<br/></span>)}
          {(errorMessage.requestedValue != null && errorMessage.requestedValue !== undefined) && (
            <div>{t('mailTemplate.ruleTypeErrors.requested_value', { requestedValue: errorMessage.requestedValue })}</div>
          )}
          {(errorMessage.asyncRequestedValue != null && errorMessage.asyncRequestedValue !== undefined) && (
            <div>{t('mailTemplate.ruleTypeErrors.async_requested_value', { asyncRequestedValue: errorMessage.asyncRequestedValue })}</div>
          )}
        </>
      )
      break
    case 'B2B_PRODUCT_DETAIL_SEARCH_COUNT':
      fireErrorModal(
        t('mailTemplate.ruleTypeErrors.b2b_product_detail_search_count_limit_title', { limit: errorMessage.limit }),
        buildMessage(
          t('mailTemplate.ruleTypeErrors.b2b_product_detail_search_count_limit_text', { currentValue: errorMessage.currentValue }),
          errorMessage
        )
      )
      break
    case 'CONTACT_FIRM_SEARCH':
      fireErrorModal(
        t('mailTemplate.ruleTypeErrors.contact_firm_search_title', { limit: errorMessage.limit }),
        t('mailTemplate.ruleTypeErrors.contact_firm_search_text', { currentValue: errorMessage.currentValue })
      )
      break
    case 'CONTACT_EMAIL_SEARCH':
      fireErrorModal(
        t('mailTemplate.ruleTypeErrors.contact_email_search_title', { limit: errorMessage.limit }),
        t('mailTemplate.ruleTypeErrors.contact_email_search_text', { currentValue: errorMessage.currentValue })
      )
      break
    case 'P7_FIRM_DOWNLOAD_COUNT':
    case 'ALL_FIRM_DOWNLOAD_COUNT':
    case 'CAMPAIGN_FIRM_DOWNLOAD_COUNT':
    case 'MARKET_REPORT_EXCEL_DOWNLOAD_COUNT':
    case 'TRADE_REGISTRY_FIRM_DOWNLOAD_COUNT':
      fireErrorModal(
        t('error_excel_download_count_limit_title', { limit: errorMessage.limit }),
        t('error_excel_download_count_limit_text', { currentValue: errorMessage.currentValue })
      )
      break
    case 'ALL_FIRM_VIEW_COUNT':
      fireErrorModal(
        t('error_all_view_limit_title', { limit: errorMessage.limit }),
        t('error_all_view_limit_text', { currentValue: errorMessage.currentValue })
      )
      break
    case 'P7_FIRM_VIEW_COUNT':
      fireErrorModal(
        t('error_p7_view_limit_title',
          { limit: errorMessage.limit }),
        t('error_p7_view_limit_text',
          { currentValue: errorMessage.currentValue })
      )
      break
    case 'TRADE_REGISTRY_FIRM_VIEW_COUNT':
      fireErrorModal(
        t('error_treg_total_view_limit_title', { limit: errorMessage.limit }),
        t('error_treg_total_view_limit_text', { currentValue: errorMessage.currentValue })
      )
      break
    case 'EXCEL_EXPORT_NOT_ALLOWED_FOR_STATUS':
      fireErrorModal(
        t('mailTemplate.excelExportErrors.notAllowedForStatus.title'),
        t('mailTemplate.excelExportErrors.notAllowedForStatus.text')
      )
      break
    case 'EXCEL_EXPORT_BUSINESS_ERROR':
      fireErrorModal(
        t('mailTemplate.excelExportErrors.businessError.title'),
        t('mailTemplate.excelExportErrors.businessError.text')
      )
      break
    case 'ExcelGeneratorExceptionDetail':
      fireErrorModal(
        t('mailTemplate.excelExportErrors.generatorError.title'),
        t('mailTemplate.excelExportErrors.generatorError.text')
      )
      break
    case 'GENERIC_HTTP_ERROR':
    case 'GENERIC_NETWORK_ERROR':
      fireErrorModal(
        t('generic_error_header'),
        t('generic_error_text'),
        `${process.env.PUBLIC_URL}/${languageGSD}/login`,
        t('generic_error_login_button')
      )
      break
  }
}

const B2BErrorModalHandler = () => {
  const { t } = useTranslation()

  const languageGSD = useGlobalStoreData.language()
  const errorMessage = useEndpointStatusData.errorMessage()
  const retryCallback = useEndpointStatusData.retryCallback()
  const { setEndpointStatus, setRetryCallback } = useEndpointStatusActions()

  const [modalFail, setModalFail] = useState(false)
  const [errorModalMessage, setErrorModalMessage] = useState()
  const [errorModalTitle, setErrorModalTitle] = useState()
  const [errorModalHref, setErrorModalHref] = useState(null)
  const [errorModalLinkText, setErrorModalLinkText] = useState(null)

  const [actionModalFail, setActionModalFail] = useState(false)
  const [actionModalMessage, setActionModalMessage] = useState()
  const [actionModalTitle, setActionModalTitle] = useState()
  const [actionModalErrorData, setActionModalErrorData] = useState(null)

  const fireErrorModal = (title, message, href = null, linkText = null) => {
    setErrorModalHref(href)
    setErrorModalLinkText(linkText)
    setErrorModalTitle(title)
    setErrorModalMessage(message)
    setModalFail(true)
  }

  const fireActionErrorModal = (title, message, errorData) => {
    setActionModalTitle(title)
    setActionModalMessage(message)
    setActionModalErrorData(errorData)
    setActionModalFail(true)
  }

  const handleRetryWithLimit = () => {
    if (retryCallback && actionModalErrorData) {
      const forcedFirmLimit = actionModalErrorData.limit -
        actionModalErrorData.currentValue -
        (actionModalErrorData.asyncRequestedValue || 0)

      retryCallback(forcedFirmLimit)
      setActionModalFail(false)
    }
  }

  const getForcedFirmLimit = () => {
    if (actionModalErrorData) {
      return actionModalErrorData.limit -
        actionModalErrorData.currentValue -
        (actionModalErrorData.asyncRequestedValue || 0)
    }
    return 0
  }

  useEffect(() => {
    showErrorModal(
      fireErrorModal,
      fireActionErrorModal,
      errorMessage,
      t,
      languageGSD
    )
  }, [errorMessage, t, languageGSD])

  return (
    <>
      <ErrorModal
        isOpen={modalFail}
        toggleModalFail={() => setModalFail((prevState) => !prevState)}
        title={errorModalTitle}
        message={errorModalMessage}
        linkText={errorModalLinkText}
        href={errorModalHref}
        clearErrorState={() => { setEndpointStatus('errorMessage') }}
      />
      <ActionErrorModal
        isOpen={actionModalFail}
        toggleModal={() => setActionModalFail((prevState) => !prevState)}
        title={actionModalTitle}
        message={actionModalMessage}
        icon={<Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-alert bg-warning"></Icon>}
        clearErrorState={() => {
          setEndpointStatus('errorMessage')
          setRetryCallback(null)
        }}
        primaryAction={getForcedFirmLimit() > 0
          ? {
              label: t('mailTemplate.ruleTypeErrors.continue_with_allowed_limit', { forcedFirmLimit: getForcedFirmLimit() }),
              onClick: handleRetryWithLimit
            }
          : null}
        secondaryAction={{
          label: t('common.close')
        }}
      />
    </>
  )
}

export default B2BErrorModalHandler
